/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Setup_FormatInputs */

const cs_import_setup_format = /** @type {(inputs: Import_Setup_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co importujete?`)
};

const en_import_setup_format = /** @type {(inputs: Import_Setup_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are you importing?`)
};

/**
* | output |
* | --- |
* | "What are you importing?" |
*
* @param {Import_Setup_FormatInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_setup_format = /** @type {((inputs?: Import_Setup_FormatInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Setup_FormatInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_setup_format(inputs)
	return cs_import_setup_format(inputs)
});